"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyType = void 0;
var PropertyType;
(function (PropertyType) {
    PropertyType["SINGLE_FAMILY"] = "SFH";
    PropertyType["CONDOMINIUM"] = "CON";
    PropertyType["MULTI_FAMILY_2_UNITS"] = "24U";
    PropertyType["MODULAR_HOME"] = "MOD";
    PropertyType["MANUFACTURED_HOME_ON_FOUNDATION"] = "MAN";
})(PropertyType = exports.PropertyType || (exports.PropertyType = {}));
